<template>
  <div>
    <!-- Error Alert -->
    <b-alert
      v-if="errors"
      variant="danger"
      show
      dismissible
      class="mb-3"
      @dismissed="errors = ''"
    >
      {{ errors }}
    </b-alert>

    <b-row>
      <b-col md="2">
        <b-form-group
          label="POB Number"
        >
          <b-form-input
            v-model="pobNumber"
            placeholder="POB Number"
            @input="filtersChangeHandler"
          />
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group
          label="Company"
        >
          <custom-v-select
            id="company"
            v-model="selectedCompanies"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="companyOptions"
            label="text"
            placeholder="Select Company"
            multiple
            :close-on-select="false"
            :deselect-from-dropdown="true"
            @input="filtersChangeHandler"
          />
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group
          label="MR"
          label-for="mr"
        >
          <custom-v-select
            id="mr"
            v-model="selectedMR"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="mrOptions"
            label="text"
            placeholder="Select MR"
            multiple
            :close-on-select="false"
            :deselect-from-dropdown="true"
            @input="filtersChangeHandler"
          />
        </b-form-group>
      </b-col>
      <b-col md="2">
        <b-form-group
          label="POB Status"
        >
          <custom-v-select
            v-model="selectedStatusOption"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="statusOptions"
            label="text"
            placeholder="Select Option"
            multiple
            @input="filtersChangeHandler"
          />
        </b-form-group>
      </b-col>
      <b-col md="2">
        <b-form-group
          label="Order Status"
        >
          <custom-v-select
            v-model="selectedBillStatusOption"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="billStatusOptions"
            label="text"
            placeholder="Select Option"
            multiple
            @input="filtersChangeHandler"
          />
        </b-form-group>
      </b-col>
      <b-col
        md="3"
      >
        <b-form-group label="Item Name">
          <custom-v-select
            v-model="selectedProducts"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="filterProductOptions"
            label="name"
            placeholder="Search Item Name"
            multiple
            :close-on-select="false"
            :deselect-from-dropdown="true"
            @search="onProductSearch"
            @input="handleProductChange"
          />
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group
          label="Party"
        >
          <custom-v-select
            id="party"
            v-model="selectedParties"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="partyOptions"
            label="text"
            placeholder="Select Party"
            multiple
            :close-on-select="false"
            :deselect-from-dropdown="true"
            @input="filtersChangeHandler"
          />
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group
          label="Created On"
        >
          <flat-picker
            v-model="createdDateRange"
            placeholder="Select Date Range"
            :config="{ mode: 'range'}"
          />
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group
          label="Placed On"
        >
          <flat-picker
            v-model="placedOnDateRange"
            placeholder="Select Date Range"
            :config="{ mode: 'range'}"
          />
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group
          label="Created By"
        >
          <custom-v-select
            v-model="selectedCreatedBy"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="userOptions"
            label="fullname"
            placeholder="Select Option"
            multiple
            @input="filtersChangeHandler"
          />
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group
          label="Placed By"
        >
          <custom-v-select
            v-model="selectedPlacedBy"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="userOptions"
            label="fullname"
            placeholder="Select Option"
            multiple
            @input="filtersChangeHandler"
          />
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  VBTooltip, BRow, BCol, BFormGroup, BFormInput, BAlert,
} from 'bootstrap-vue'
import axios from 'axios'
import CustomVSelect from '@/components/UI/CustomVSelect.vue'
import FlatPicker from '@/components/UI/FlatPicker.vue'
import dateMixin from '@/mixins/dateMixin'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BAlert,
    CustomVSelect,
    FlatPicker,
  },
  mixins: [dateMixin],
  data() {
    return {
      errors: '',
      partyOptions: [],
      selectedParties: [],
      companyOptions: [],
      selectedCompanies: [],
      products: [],
      selectedProducts: [],
      productOptions: [],
      filterProductOptions: [],
      productSearchTimeout: null,
      selectedCreatedBy: [],
      selectedPlacedBy: [],
      selectedStatusOption: [{ text: 'Pending', value: 'pending' }],
      selectedBillStatusOption: [],
      selectedAreas: [],
      mrOptions: [],
      userOptions: [],
      selectedMR: [],
      statusOptions: [
        { text: 'Pending', value: 'pending' },
        { text: 'Fully Approved', value: 'fully approved' },
        { text: 'Partially Approved', value: 'partially approved' },
        { text: 'Re-Approved', value: 're-approved' },
        { text: 'Rejected', value: 'rejected' },
      ],
      billStatusOptions: [
        { text: 'Created', value: 'CREATED' },
        { text: 'Confirmed', value: 'CONFIRMED' },
        { text: 'Picked', value: 'PICKED' },
        { text: 'Delivered', value: 'DELIVERED' },
        { text: 'Deleted', value: 'DELETED' },
        { text: 'Failed', value: 'FAILED' },
      ],
      pobNumber: '',
      createdDateRange: '',
      placedOnDateRange: null,
      debounceTimer: null,
    }
  },
  watch: {
    createdDateRange(newValue) {
      if (newValue) {
        const [fromDate, toDate] = newValue.split(' to ')
        if (fromDate && toDate) {
          this.filtersChangeHandler()
        }
      } else if (newValue === '') {
        this.filtersChangeHandler()
      }
    },
    placedOnDateRange(newValue) {
      if (newValue) {
        const [fromDate, toDate] = newValue.split(' to ')
        if (fromDate && toDate) {
          this.filtersChangeHandler()
        }
      } else if (newValue === '') {
        this.filtersChangeHandler()
      }
    },
  },
  created() {
    this.fetchOptions()
    this.fetchProducts()
  },
  beforeDestroy() {
    // Clean up timer when component is destroyed
    if (this.productSearchTimeout) {
      clearTimeout(this.productSearchTimeout)
    }
  },
  methods: {
    debouncedFiltersChange() {
      // Clear the existing timer
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer)
      }

      // Set a new timer
      this.debounceTimer = setTimeout(() => {
        this.filtersChangeHandler()
      }, 500) // 500ms delay
    },

    onProductSearch(search) {
      if (this.productSearchTimeout) {
        clearTimeout(this.productSearchTimeout)
      }

      this.productSearchTimeout = setTimeout(() => {
        this.filterProducts(search)
      }, 300)
    },

    filterProducts(search) {
      if (!search || search.trim() === '') {
        // Show only first 15 items when no search
        this.filterProductOptions = this.productOptions.slice(0, 15)
      } else {
        // Filter products by search term
        const searchLower = search.toLowerCase()
        const filtered = this.productOptions.filter(product => product.name.toLowerCase().includes(searchLower)
          || (product.code && product.code.toLowerCase().includes(searchLower)))

        // Limit to first 50 results for performance
        this.filterProductOptions = filtered.slice(0, 50)
      }
    },

    async fetchProducts() {
      try {
        const productRes = await axios.get('/marg/product_options')
        this.productOptions = productRes.data.data.map(product => ({
          id: product.code,
          code: product.code,
          name: product.name,
          display_text: product.name,
        }))

        // Initialize with first 15 products
        this.filterProductOptions = this.productOptions.slice(0, 15)
      } catch (error) {
        this.errors = error.response?.data?.error || 'Failed to fetch products. Please try again.'
      }
    },

    handleProductChange(selectedProducts) {
      this.selectedProducts = selectedProducts || []
      this.filtersChangeHandler()
    },

    async fetchOptions() {
      try {
        // Fetch party options
        const partyRes = await axios.get('/accounts/buyers_options')
        this.partyOptions = partyRes.data.data

        // Fetch company options
        const companyRes = await axios.get('/company_options')
        this.companyOptions = companyRes.data.data

        // Fetch MR options
        const mrRes = await axios.get('/mr')
        this.mrOptions = mrRes.data.results.map(item => {
          // Find primary mobile number
          const primaryMobile = item.mr_mobiles?.find(mobile => mobile.is_primary)?.mobile || ''

          // Create display text with name and primary mobile
          const displayText = primaryMobile
            ? `${item.name} ( ${primaryMobile} )`
            : item.name

          return {
            id: item.id,
            text: displayText,
            name: item.name,
            mobile: primaryMobile,
          }
        })
        const { data: retailer } = await axios.get('/delivery/users_list?retailers_only=true')
        const retailersId = retailer.map(i => i.id)
        const { data: usersList } = await axios.get('/delivery/users_list')
        this.userOptions = usersList.filter(user => !retailersId.includes(user.id))
        // Fetch salesman options
      } catch (error) {
        this.errors = error.response?.data?.error || 'Failed to load filter options. Please refresh the page.'
      }
    },
    filtersChangeHandler() {
      const filtersdata = {}
      if (this.pobNumber) {
        filtersdata.pob_number = this.pobNumber
      }
      if (this.selectedCompanies) {
        filtersdata.company = this.selectedCompanies.map(item => item.id)
      }
      if (this.selectedMR) {
        filtersdata.mrs = this.selectedMR.map(item => item.id)
      }

      if (this.selectedStatusOption) {
        filtersdata.pob_status = this.selectedStatusOption.map(item => item.value)
      }
      if (this.selectedBillStatusOption) {
        filtersdata.order_status = this.selectedBillStatusOption.map(item => item.value)
      }
      if (this.selectedParties) {
        filtersdata.parties = this.selectedParties.map(item => item.id)
      }
      if (this.selectedProducts && this.selectedProducts.length > 0) {
        filtersdata.items = this.selectedProducts.map(product => product.code || product.id)
      }
      if (this.selectedCreatedBy) {
        filtersdata.created_by = this.selectedCreatedBy.map(item => item.id)
      }
      if (this.selectedPlacedBy) {
        filtersdata.placed_by = this.selectedPlacedBy.map(item => item.id)
      }
      if (this.createdDateRange) {
        const [chequeDateFrom, chequeDateTo] = this.createdDateRange.split(' to ')
        if (chequeDateFrom && chequeDateTo) {
          filtersdata.created_date_from = chequeDateFrom
          filtersdata.created_date_to = chequeDateTo
        }
      }

      if (this.placedOnDateRange) {
        const [depositedDateFrom, depositedDateTo] = this.placedOnDateRange.split(' to ')
        if (depositedDateFrom && depositedDateTo) {
          filtersdata.placed_date_from = depositedDateFrom
          filtersdata.placed_date_to = depositedDateTo
        }
      }

      this.$emit('filtersUpdated', filtersdata)
    },
  },
}
</script>
